import React, { useEffect } from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import { getCategoryHeirarchy } from '../../../redux/getCategoryHeirarchy';
import { useDispatch } from 'react-redux';
import EditLevelForm from '../../../component/levelComps/EditLevelForm';

const EditLevel = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCategoryHeirarchy());
  }, []);
  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Level3"  pagename="Edit Category" buttonText="Update category"/>
      <EditLevelForm />
    </div>
  );
};

export default EditLevel;
